// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CREATE_METERING_USAGE_CHART_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CREATE_METERING_USAGE_CHART,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      outputChart: {
        systemName: 'outputChart',
        displayName: 'Output chart',
        kind: PipelineStepDataKind.CHART,
        isMulti: false,
        isRequired: true
      },
      outputDataframe: {
        systemName: 'outputDataframe',
        displayName: 'Output data frame',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      dateRange: {
        kind: 'shape',
        required: true,
        fields: {
          startDate: {
            kind: 'date',
            required: false
          },
          endDate: {
            kind: 'date',
            required: false
          }
        }
      },
      productType: {
        kind: 'enum',
        required: false,
        choices: [
          'AI_ASK',
          'CHAT',
          'COMPOSE',
          'DATA_ENTRY_AGENT',
          'DEEP_RESEARCH',
          'STRUCTURE_PREDICTION'
        ]
      },
      userId: {
        kind: 'domain',
        required: false,
        types: [
          'USER',
          'ROUTINE'
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
